import React, { ReactNode } from 'react'
import { T } from '@transifex/react'

export type TDriverDriverType = `PRIMARY` | `SUBSTITUTE`

export const TDriverDriverTypeLabelMap: Record<TDriverDriverType, ReactNode> = {
  PRIMARY: <T _str="Primary" />,
  SUBSTITUTE: <T _str="Substitute" />,
}
